import { render, staticRenderFns } from "./UserPermissionForm.vue?vue&type=template&id=d6ac580a"
import script from "./UserPermissionForm.vue?vue&type=script&lang=js"
export * from "./UserPermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports